import { Reducer } from 'react';

import { ICustomer } from 'services/customerService';
import { IUser } from 'utils/token';

export enum AuthTypes {
  LOGIN = 'LOGIN',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS',
  SET_CUSTOMER = 'SET_CUSTOMER',
}

export interface AuthSharedState {
  user?: IUser;
  customer: ICustomer;
}

export interface AuthState extends AuthSharedState {
  error?: any;
  loading?: boolean;
}

const initialState: AuthState = {
  user: undefined,
  customer: {} as ICustomer,
  error: undefined,
  loading: false,
};

const reducer: Reducer<AuthState, any> = (state, action) => {
  switch (action.type) {
    case AuthTypes.LOGIN:
      return {
        ...state,
        user: undefined,
        error: undefined,
        loading: true,
      };
    case AuthTypes.LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
        error: undefined,
        loading: false,
      };
    case AuthTypes.SIGNOUT_SUCCESS:
      return {
        ...state,
        ...initialState,
      };
    case AuthTypes.SET_CUSTOMER:
      return {
        ...state,
        customer: action.payload,
      };
    default:
      throw new Error('Auth action not implemented');
  }
};

export { initialState };

export default reducer;
